module.exports = __webpack_public_path__ + "static/media/Strategicpartnesnr.ff27b0ee.png";